import { render } from "./MyPaletteView.vue?vue&type=template&id=5414cdd6&scoped=true&ts=true"
import script from "./MyPaletteView.vue?vue&type=script&lang=ts"
export * from "./MyPaletteView.vue?vue&type=script&lang=ts"

import "./MyPaletteView.vue?vue&type=style&index=0&id=5414cdd6&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5414cdd6"]])

export default __exports__